/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';
import Icon from '../Icon';
import styles from './styles.module.scss';

type CommonUse = 'primary' | 'secondary' | 'danger' | 'superBlue' | 'ghost';
type Props = {
  name?: string,
  onClick?: (e: SyntheticMouseEvent<HTMLElement>) => any,
  type?: 'button' | 'submit' | 'reset',
  use?: CommonUse,
  outlined?: boolean,
  containsIcon?: boolean,
  disabled?: boolean,
  fill?: boolean,
  small?: boolean,
  children?: Node,
  loading?: boolean,
  transparent?: boolean,
  fixedWidth?: boolean,
  buttonMaskShow?: boolean,
  className?: string,
  customBackground?: string,
  isFreeUser?: boolean,
  setFreeModalVisible?: () => void,
};

const Button = ({
  name = '',
  type = 'button',
  onClick,
  use = 'primary',
  outlined,
  containsIcon = false,
  disabled = false,
  fill = false,
  small = false,
  loading = false,
  transparent = false,
  buttonMaskShow = false,
  fixedWidth = false,
  children,
  className = '',
  customBackground = '',
  isFreeUser,
  setFreeModalVisible,
}: Props) => (
  <>
    <button
      style={{ background: customBackground }}
      type={type}
      disabled={disabled || loading}
      className={classnames(
        styles.button,
        styles[use],
        {
          [styles.disabled]: disabled,
          [styles.outlined]: outlined,
          [styles.fill]: fill,
          [styles.icon]: containsIcon,
          [styles.small]: small,
          [styles.loading]: loading,
          [styles.transparent]: transparent,
          [styles.fixedWidth]: fixedWidth,
        },
        className,
      )}
      onClick={onClick}
      onMouseOver={() => (isFreeUser ? setFreeModalVisible(true) : null)}
      onFocus={() => (isFreeUser ? setFreeModalVisible(true) : null)}
      onMouseOut={() => (isFreeUser ? setFreeModalVisible(false) : null)}
      onBlur={() => (isFreeUser ? setFreeModalVisible(false) : null)}
    >
      <div
        className={
          classnames(styles.buttonMask,
            { [styles.cardButtonMaskShow]: buttonMaskShow })
        }
      />
      <div className={styles.buttonContent}>{children || name}</div>
      <Icon icon="circle-o-notch" spin className={styles.spinner} />
    </button>
  </>
);

export default Button;
